import React, { useState } from "react";
import cx from "classnames";

import { func, string, array } from "prop-types";
import { selectedFacetShape } from "../../../common/dynamicSearch.js";

import useClickAway from "../../../common/useClickAway.js";

import Checkbox from "../../FormItems/Checkbox.jsx";

const propTypes = {
  filterLabel: string,
  label: string,
  id: string,
  values: array,
  childGroups: array,
  onFacetChange: func.isRequired,
  selectedFacets: selectedFacetShape.isRequired,
  onClearFacetGroup: func,
};

const FilterDropdown = (props) => {
  const {
    filterLabel,
    label,
    values,
    id,
    onFacetChange,
    childGroups,
    selectedFacets,
    onClearFacetGroup,
  } = props;

  const [isOpen, setOpen] = useState(false);
  const filterDropdownRef = useClickAway({ isOpen, setOpen });

  if (!values || values.length < 1) {
    return null;
  }

  const renderGroup = (values) => {
    return (
      values &&
      values.map((value, ind) => {
        return (
          <li key={`${value.id}-${ind}`}>
            <Checkbox
              label={`${value.name} (${value.count})`}
              value={value.id}
              checked={value.selected}
              onChange={() => onFacetChange(id, value.id)}
            />
            {value.childValues && value.childValues.length > 0 && (
              <ul className="filter-dropdown__sub-group">
                {renderGroup(value.childValues)}
              </ul>
            )}
          </li>
        );
      })
    );
  };

  const renderSelectedGroup = (values) => {
    return (
      values &&
      values.map((value, ind) => {
        return value.selected === true ? (
          <>
            <li key={`selected-${value.id}-${ind}`}>
              <Checkbox
                label={`${value.name} (${value.count})`}
                value={value.id}
                checked={value.selected}
                onChange={() => onFacetChange(id, value.id)}
              />
            </li>
            {value.childValues &&
              value.childValues.length > 0 &&
              renderSelectedGroup(value.childValues)}
          </>
        ) : (
          value.childValues &&
            value.childValues.length > 0 &&
            renderSelectedGroup(value.childValues)
        );
      })
    );
  };

  const count =
    selectedFacets[id] && Object.keys(selectedFacets[id]).length > 0
      ? `(${Object.keys(selectedFacets[id]).length})`
      : "";

  const handleMenuClick = () => {
    // analytics
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      type: `DCL Facet ${isOpen ? "Closed" : "Opened"}`,
      event: "dropdownClick",
      dropdownSelection: label,
    });

    setOpen(!isOpen);
  };

  return (
    <section ref={filterDropdownRef} className="filter-dropdown">
      {filterLabel ? (
        <div
          id={`filter-${label}-${id}`.replace(/\s/g, "")}
          className="filter-dropdown__eyebrow"
        >
          {label} {count}
        </div>
      ) : null}
      <div className="filter-dropdown__header">
        <button
          aria-labelledby={`filter-${label}-${id}`.replace(/\s/g, "")}
          aria-expanded={isOpen}
          type="button"
          id={id}
          onClick={handleMenuClick}
          className="filter-dropdown__open-button"
        >
          <span>
            <span className="filter-dropdown__filter-text-wrapper">
              {filterLabel ? `${filterLabel} ${label}` : `${label} ${count}`}
            </span>
          </span>
        </button>
      </div>
      <div
        className={cx("filter-dropdown__panel", {
          "filter-dropdown__panel--is-open": isOpen,
        })}
      >
        {selectedFacets[id] && Object.keys(selectedFacets[id]).length > 0 && (
          <div className="filter-dropdown__clear">
            <button
              type="button"
              className="filter-dropdown__clear-button btn btn--primary"
              onClick={() => onClearFacetGroup(id)}
            >
              Clear All
            </button>
          </div>
        )}
        <div className="filter-dropdown__menu-list">
          <ul className="filter-dropdown__group" aria-label={label}>
            {renderGroup(values)}
          </ul>
          {childGroups &&
            childGroups.map((group, ind) => {
              return (
                <div key={`child-${group.id}-${ind}`}>
                  <div className="filter-dropdown__divider">{group.label}</div>
                  <ul
                    className="filter-dropdown__group"
                    aria-label={group.label}
                  >
                    {renderGroup(group.values)}
                  </ul>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

FilterDropdown.propTypes = propTypes;
export default React.memo(FilterDropdown);
